import r from "./keys.js";
function t(t, e) {
  var n = r(e),
    a = n.length;
  if (null == t) return !a;
  for (var f = Object(t), i = 0; i < a; i++) {
    var u = n[i];
    if (e[u] !== f[u] || !(u in f)) return !1;
  }
  return !0;
}
export { t as default };